import React from "react";
import logger from "../../utils/logger";

export default function PrintCaseDetails({ caseData }) {
  // طباعة البيانات للتحقق
  logger.debug("PrintCaseDetails received data:", caseData);

  // تحديد الخصم النشط (سواء كان كائناً مفرداً أو مصفوفة)
  const activeOpponent = caseData.opponent || (caseData.opponents && caseData.opponents[0]) || {};

  // دالة تنسيق التاريخ
  const formatDate = (dateString) => {
    if (!dateString || dateString === "غير محدد" || dateString === "لا يوجد") return "-";
    
    // إذا كان التاريخ يحتوي على حروف عربية أو هو سلسلة منسقة بالفعل، نعيده كما هو
    if (typeof dateString === 'string' && (dateString.includes('/') || /[\u0600-\u06FF]/.test(dateString))) {
       return dateString;
    }

    const date = new Date(dateString);
    // التحقق من صحة التاريخ
    if (isNaN(date.getTime())) return dateString; // إذا فشل التحويل، نعيد النص الأصلي بدلاً من "-"
    
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
  };

  // ... (بقية الدوال المساعدة تبقى كما هي)

  // حساب المبلغ المتبقي
  const calculateRemainingAmount = () => {
    const totalFees = Number(caseData.agreed_fees || caseData.fees) || 0;
    let totalPaid = 0;

    if (caseData.payments && caseData.payments.length > 0) {
      totalPaid = caseData.payments.reduce(
        (sum, payment) => sum + Number(payment.amount),
        0
      );
    }

    return totalFees - totalPaid;
  };

  // حساب إجمالي المصاريف
  const calculateTotalExpenses = () => {
    if (caseData.expenses && caseData.expenses.length > 0) {
      return caseData.expenses.reduce(
        (sum, expense) => sum + Number(expense.amount || 0),
        0
      );
    }
    return 0;
  };

  return (
    <div className="print-only" style={{ padding: "30px", fontFamily: "Arial, sans-serif", color: "#333" }}>
      {/* الشعار والترويسة */}
      <div style={{ textAlign: "center", marginBottom: "40px", borderBottom: "2px solid #cbd5e1", paddingBottom: "20px" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "bold", color: "#1e293b", margin: "0 0 10px 0" }}>
          نظام المرجع برو لإدارة مكاتب المحاماة
        </h1>
        <h2 style={{ fontSize: "20px", color: "#64748b", margin: "10px 0" }}>
          تقرير تفاصيل القضية
        </h2>
        <p style={{ color: "#94a3b8", fontSize: "12px", margin: "5px 0" }}>
          تاريخ التقرير: {formatDate(new Date())}
        </p>
      </div>

      {/* رقم القضية وتاريخها بشكل بارز */}
      <div style={{ 
        backgroundColor: "#f8fafc", 
        border: "1px solid #cbd5e1", 
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "30px",
        textAlign: "center"
      }}>
        <h3 style={{ fontSize: "22px", fontWeight: "bold", color: "#334155", margin: "0 0 10px 0" }}>
          قضية رقم: {caseData.case_number || caseData.number}
        </h3>
        <p style={{ fontSize: "16px", color: "#475569", margin: "5px 0" }}>
          <strong>عنوان القضية:</strong> {caseData.title || "-"}
        </p>
        <p style={{ fontSize: "14px", color: "#64748b", margin: "5px 0" }}>
          <strong>تاريخ التسجيل:</strong> {formatDate(caseData.filing_date || caseData.created_at || caseData.createdAt || caseData.date)}
        </p>
      </div>

      {/* القسم الأول: المعلومات الأساسية */}
      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ 
          fontSize: "18px", 
          fontWeight: "bold", 
          borderBottom: "2px solid #e2e8f0",
          paddingBottom: "10px",
          marginBottom: "15px",
          color: "#334155"
        }}>
          📋 معلومات المحكمة والقضية
        </h2>
        
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px", fontSize: "14px" }}>
          <tbody>
            <tr style={{ backgroundColor: "#f8fafc" }}>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", width: "25%", color: "#475569" }}>
                رقم القضية في المحكمة
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                {caseData.court_case_number || "-"}
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", width: "25%", color: "#475569" }}>
                المحكمة
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                {caseData.court_name || caseData.court || "-"}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", color: "#475569" }}>
                نوع القضية
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                {caseData.case_type || "-"}
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", color: "#475569" }}>
                حالة القضية
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                <span style={{ 
                  backgroundColor: "#f1f5f9", 
                  color: "#334155", 
                  padding: "2px 8px", 
                  borderRadius: "4px",
                  fontWeight: "bold",
                  border: "1px solid #cbd5e1"
                }}>
                  {caseData.status || "-"}
                </span>
              </td>
            </tr>
            <tr style={{ backgroundColor: "#f8fafc" }}>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", color: "#475569" }}>
                المحامي المسؤول
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0" }}>
                {caseData.lawyer || caseData.assigned_lawyer || "-"}
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", color: "#475569" }}>
                تاريخ الجلسة القادمة
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", color: "#dc2626", fontWeight: "bold" }}>
                {formatDate(caseData.next_session_date)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", fontWeight: "bold", color: "#475569" }}>
                قيمة الأتعاب المتفق عليها
              </td>
              <td style={{ padding: "10px", border: "1px solid #e2e8f0", color: "#059669", fontWeight: "bold" }} colSpan="3">
                {caseData.agreed_fees || caseData.fees || 0} دينار
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* القسم الثاني: تفاصيل القضية */}
      {(caseData.description || caseData.notes) && (
        <div style={{ marginBottom: "30px" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            📝 تفاصيل القضية والملاحظات
          </h2>
          
          {caseData.description && (
            <div style={{ 
              backgroundColor: "#f8fafc", 
              padding: "15px", 
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              marginBottom: "15px"
            }}>
              <h3 style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px", color: "#475569" }}>
                وصف القضية:
              </h3>
              <p style={{ lineHeight: "1.6", color: "#334155", whiteSpace: "pre-line", fontSize: "14px" }}>
                {caseData.description}
              </p>
            </div>
          )}

          {caseData.notes && (
            <div style={{ 
              backgroundColor: "#fffbeb", 
              padding: "15px", 
              borderRadius: "8px",
              border: "1px solid #fef3c7"
            }}>
              <h3 style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "8px", color: "#b45309" }}>
                ملاحظات إضافية:
              </h3>
              <p style={{ lineHeight: "1.6", color: "#92400e", whiteSpace: "pre-line", fontSize: "14px" }}>
                {caseData.notes}
              </p>
            </div>
          )}
        </div>
      )}

      {/* القسم الثالث: معلومات الأطراف */}
      <div style={{ marginBottom: "30px", pageBreakBefore: "always" }}>
        <h2 style={{ 
          fontSize: "18px", 
          fontWeight: "bold", 
          borderBottom: "2px solid #e2e8f0",
          paddingBottom: "10px",
          marginBottom: "15px",
          color: "#334155"
        }}>
          👥 معلومات الأطراف
        </h2>
        
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          {/* المدعي */}
          <div style={{ 
            border: "1px solid #bfdbfe", 
            borderRadius: "8px",
            padding: "15px",
            backgroundColor: "#eff6ff"
          }}>
            <h3 style={{ 
              fontSize: "16px", 
              fontWeight: "bold", 
              color: "#1e40af",
              marginBottom: "10px",
              borderBottom: "1px solid #dbeafe",
              paddingBottom: "8px"
            }}>
              🔵 المدعي (العميل)
            </h3>
            <table style={{ width: "100%", fontSize: "13px" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af", width: "30%" }}>الاسم:</td>
                  <td style={{ padding: "6px 0", color: "#334155" }}>
                    {caseData.client_name || caseData.plaintiff || "-"}
                  </td>
                </tr>
                {caseData.clientDetails?.id_number && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>رقم الهوية:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {caseData.clientDetails.id_number}
                    </td>
                  </tr>
                )}
                {(caseData.clientDetails?.phone || caseData.phone) && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>رقم الهاتف:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {caseData.clientDetails?.phone || caseData.phone}
                    </td>
                  </tr>
                )}
                {(caseData.clientDetails?.national_id || caseData.clientDetails?.id_number) && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>الرقم الوطني:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {caseData.clientDetails?.national_id || caseData.clientDetails?.id_number}
                    </td>
                  </tr>
                )}
                {(caseData.clientDetails?.address || caseData.address) && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>العنوان:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {caseData.clientDetails?.address || caseData.address}
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>رقم الوكالة:</td>
                  <td style={{ padding: "6px 0", color: "#334155" }}>
                    {caseData.clientDetails?.power_of_attorney_number || caseData.agency_number || "-"}
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: "6px 0", fontWeight: "bold", color: "#1e40af" }}>تاريخ الوكالة:</td>
                  <td style={{ padding: "6px 0", color: "#334155" }}>
                    {formatDate(caseData.clientDetails?.power_of_attorney_date || caseData.agency_date)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* المدعى عليه */}
          <div style={{ 
            border: "1px solid #fecaca", 
            borderRadius: "8px",
            padding: "15px",
            backgroundColor: "#fef2f2"
          }}>
            <h3 style={{ 
              fontSize: "16px", 
              fontWeight: "bold", 
              color: "#991b1b",
              marginBottom: "10px",
              borderBottom: "1px solid #fee2e2",
              paddingBottom: "8px"
            }}>
              🔴 المدعى عليه (الخصم)
            </h3>
            <table style={{ width: "100%", fontSize: "13px" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b", width: "30%" }}>الاسم:</td>
                  <td style={{ padding: "6px 0", color: "#334155" }}>
                    {activeOpponent.name || caseData.opponent_name || caseData.defendant || "-"}
                  </td>
                </tr>
                {activeOpponent.id_number && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>رقم الهوية:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.id_number}
                    </td>
                  </tr>
                )}
                {activeOpponent.phone && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>رقم الهاتف:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.phone}
                    </td>
                  </tr>
                )}
                {(activeOpponent.national_id || activeOpponent.id_number) && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>الرقم الوطني:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.national_id || activeOpponent.id_number}
                    </td>
                  </tr>
                )}
                {activeOpponent.address && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>العنوان:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.address}
                    </td>
                  </tr>
                )}
                <tr>
                  <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>محامي الخصم:</td>
                  <td style={{ padding: "6px 0", color: "#334155" }}>
                    {activeOpponent.lawyer_name || caseData.opponent_lawyer || "-"}
                  </td>
                </tr>
                {(activeOpponent.lawyer_phone || caseData.opponent_lawyer_phone) && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>هاتف المحامي:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.lawyer_phone || caseData.opponent_lawyer_phone}
                    </td>
                  </tr>
                )}
                {activeOpponent.lawyer_office && (
                  <tr>
                    <td style={{ padding: "6px 0", fontWeight: "bold", color: "#991b1b" }}>مكتب المحامي:</td>
                    <td style={{ padding: "6px 0", color: "#334155" }}>
                      {activeOpponent.lawyer_office}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* القسم الرابع: الملخص المالي */}
      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ 
          fontSize: "18px", 
          fontWeight: "bold", 
          borderBottom: "2px solid #e2e8f0",
          paddingBottom: "10px",
          marginBottom: "15px",
          color: "#334155"
        }}>
          💰 الملخص المالي
        </h2>
        
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(4, 1fr)", 
          gap: "15px",
          marginBottom: "20px"
        }}>
          <div style={{ 
            backgroundColor: "#f0f9ff", 
            border: "1px solid #bae6fd",
            borderRadius: "8px",
            padding: "15px",
            textAlign: "center"
          }}>
            <p style={{ fontSize: "12px", color: "#0369a1", margin: "0 0 5px 0" }}>إجمالي الأتعاب</p>
            <p style={{ fontSize: "20px", fontWeight: "bold", color: "#0c4a6e", margin: "0" }}>
              {caseData.agreed_fees || caseData.fees || 0}
            </p>
            <p style={{ fontSize: "11px", color: "#0369a1", margin: "5px 0 0 0" }}>دينار</p>
          </div>

          <div style={{ 
            backgroundColor: "#f0fdf4", 
            border: "1px solid #bbf7d0",
            borderRadius: "8px",
            padding: "15px",
            textAlign: "center"
          }}>
            <p style={{ fontSize: "12px", color: "#15803d", margin: "0 0 5px 0" }}>المبلغ المدفوع</p>
            <p style={{ fontSize: "20px", fontWeight: "bold", color: "#14532d", margin: "0" }}>
              {caseData.payments && caseData.payments.length > 0
                ? caseData.payments.reduce((sum, payment) => sum + Number(payment.amount), 0)
                : 0}
            </p>
            <p style={{ fontSize: "11px", color: "#15803d", margin: "5px 0 0 0" }}>دينار</p>
          </div>

          <div style={{ 
            backgroundColor: "#fffbeb", 
            border: "1px solid #fde68a",
            borderRadius: "8px",
            padding: "15px",
            textAlign: "center"
          }}>
            <p style={{ fontSize: "12px", color: "#b45309", margin: "0 0 5px 0" }}>إجمالي المصاريف</p>
            <p style={{ fontSize: "20px", fontWeight: "bold", color: "#78350f", margin: "0" }}>
              {calculateTotalExpenses()}
            </p>
            <p style={{ fontSize: "11px", color: "#b45309", margin: "5px 0 0 0" }}>دينار</p>
          </div>

          <div style={{ 
            backgroundColor: "#fef2f2", 
            border: "1px solid #fecaca",
            borderRadius: "8px",
            padding: "15px",
            textAlign: "center"
          }}>
            <p style={{ fontSize: "12px", color: "#b91c1c", margin: "0 0 5px 0" }}>المبلغ المتبقي</p>
            <p style={{ fontSize: "20px", fontWeight: "bold", color: "#7f1d1d", margin: "0" }}>
              {calculateRemainingAmount()}
            </p>
            <p style={{ fontSize: "11px", color: "#b91c1c", margin: "5px 0 0 0" }}>دينار</p>
          </div>
        </div>
      </div>

      {/* القسم الخامس: جلسات القضية */}
      {caseData.sessions && caseData.sessions.length > 0 ? (
        <div style={{ marginBottom: "30px", pageBreakInside: "avoid" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            ⚖️ جلسات القضية ({caseData.sessions.length} جلسة)
          </h2>
          
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f1f5f9", color: "#334155", borderBottom: "2px solid #cbd5e1" }}>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0", textAlign: "center" }}>#</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>العنوان</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>التاريخ</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>الوقت</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>نوع الجلسة</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>المحكمة / الغرفة</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>القاضي</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>الحالة</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>القرار</th>
                <th style={{ padding: "10px", border: "1px solid #e2e8f0" }}>الملاحظات</th>
              </tr>
            </thead>
            <tbody>
              {caseData.sessions.map((session, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc" }}>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0", textAlign: "center", fontWeight: "bold", color: "#64748b" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.title || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {formatDate(session.date)}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0", textAlign: "center" }}>
                    {session.time || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.session_type || session.type || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.court || "-"}{session.room ? ` / ${session.room}` : ""}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.judge || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.status || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.decisions || session.decision || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #e2e8f0" }}>
                    {session.notes || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ marginBottom: "30px" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            ⚖️ جلسات القضية
          </h2>
          <p style={{ 
            padding: "20px", 
            backgroundColor: "#f8fafc", 
            border: "1px dashed #cbd5e1",
            borderRadius: "8px",
            textAlign: "center",
            color: "#64748b",
            fontStyle: "italic"
          }}>
            لم يتم تسجيل أي جلسات لهذه القضية بعد
          </p>
        </div>
      )}

      {/* القسم السادس: سجل المدفوعات */}
      {caseData.payments && caseData.payments.length > 0 ? (
        <div style={{ marginBottom: "30px", pageBreakInside: "avoid" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            💵 سجل المدفوعات ({caseData.payments.length} دفعة)
          </h2>
          
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f0fdf4", color: "#166534", borderBottom: "2px solid #bbf7d0" }}>
                <th style={{ padding: "10px", border: "1px solid #dcfce7", textAlign: "center" }}>#</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>التاريخ</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>المبلغ</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>الوصف</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>طريقة الدفع</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>المرجع</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>الحالة</th>
                <th style={{ padding: "10px", border: "1px solid #dcfce7" }}>الملاحظات</th>
              </tr>
            </thead>
            <tbody>
              {caseData.payments.map((payment, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f0fdf4" }}>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7", textAlign: "center", fontWeight: "bold", color: "#166534" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {formatDate(payment.date || payment.payment_date)}
                  </td>
                  <td style={{ 
                    padding: "8px", 
                    border: "1px solid #dcfce7",
                    fontWeight: "bold",
                    color: "#15803d"
                  }}>
                    {payment.amount} دينار
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {payment.description || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {payment.method || payment.payment_method || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {payment.reference || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {payment.status || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #dcfce7" }}>
                    {payment.notes || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ marginBottom: "30px" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            💵 سجل المدفوعات
          </h2>
          <p style={{ 
            padding: "20px", 
            backgroundColor: "#f8fafc", 
            border: "1px dashed #cbd5e1",
            borderRadius: "8px",
            textAlign: "center",
            color: "#64748b",
            fontStyle: "italic"
          }}>
            لم يتم تسجيل أي مدفوعات لهذه القضية بعد
          </p>
        </div>
      )}

      {/* القسم السابع: سجل المصاريف */}
      {caseData.expenses && caseData.expenses.length > 0 ? (
        <div style={{ marginBottom: "30px", pageBreakInside: "avoid" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            📊 سجل المصاريف ({caseData.expenses.length} مصروف)
          </h2>
          
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#fffbeb", color: "#92400e", borderBottom: "2px solid #fde68a" }}>
                <th style={{ padding: "10px", border: "1px solid #fef3c7", textAlign: "center" }}>#</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>التاريخ</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>الوصف</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>المبلغ</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>النوع</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>الحالة</th>
                <th style={{ padding: "10px", border: "1px solid #fef3c7" }}>الملاحظات</th>
              </tr>
            </thead>
            <tbody>
              {caseData.expenses.map((expense, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#fffbeb" }}>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7", textAlign: "center", fontWeight: "bold", color: "#b45309" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7" }}>
                    {formatDate(expense.date || expense.expense_date)}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7" }}>
                    {expense.description || expense.details || "-"}
                  </td>
                  <td style={{ 
                    padding: "8px", 
                    border: "1px solid #fef3c7",
                    fontWeight: "bold",
                    color: "#b45309"
                  }}>
                    {expense.amount} دينار
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7" }}>
                    {expense.type || expense.expense_type || expense.category || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7" }}>
                    {expense.status || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #fef3c7" }}>
                    {expense.notes || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ marginBottom: "30px" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            📊 سجل المصاريف
          </h2>
          <p style={{ 
            padding: "20px", 
            backgroundColor: "#f8fafc", 
            border: "1px dashed #cbd5e1",
            borderRadius: "8px",
            textAlign: "center",
            color: "#64748b",
            fontStyle: "italic"
          }}>
            لم يتم تسجيل أي مصاريف لهذه القضية بعد
          </p>
        </div>
      )}

      {/* القسم الثامن: المستندات المرفقة */}
      {caseData.documents && caseData.documents.length > 0 ? (
        <div style={{ marginBottom: "30px", pageBreakInside: "avoid" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            📁 المستندات المرفقة ({caseData.documents.length} مستند)
          </h2>
          
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#f5f3ff", color: "#5b21b6", borderBottom: "2px solid #ddd6fe" }}>
                <th style={{ padding: "10px", border: "1px solid #ede9fe", textAlign: "center" }}>#</th>
                <th style={{ padding: "10px", border: "1px solid #ede9fe" }}>اسم المستند</th>
                <th style={{ padding: "10px", border: "1px solid #ede9fe" }}>الوصف</th>
                <th style={{ padding: "10px", border: "1px solid #ede9fe" }}>النوع</th>
                <th style={{ padding: "10px", border: "1px solid #ede9fe" }}>تاريخ الإضافة</th>
                <th style={{ padding: "10px", border: "1px solid #ede9fe" }}>ملاحظات</th>
              </tr>
            </thead>
            <tbody>
              {caseData.documents.map((doc, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f3ff" }}>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe", textAlign: "center", fontWeight: "bold", color: "#6d28d9" }}>
                    {index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe" }}>
                    {doc.name || doc.file_name || doc.title || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe" }}>
                    {doc.description || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe" }}>
                    {doc.document_type || doc.type || "-"}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe" }}>
                    {formatDate(doc.created_at || doc.createdAt || doc.upload_date)}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ede9fe" }}>
                    {doc.notes || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ marginBottom: "30px" }}>
          <h2 style={{ 
            fontSize: "18px", 
            fontWeight: "bold", 
            borderBottom: "2px solid #e2e8f0",
            paddingBottom: "10px",
            marginBottom: "15px",
            color: "#334155"
          }}>
            📁 المستندات المرفقة
          </h2>
          <p style={{ 
            padding: "20px", 
            backgroundColor: "#f8fafc", 
            border: "1px dashed #cbd5e1",
            borderRadius: "8px",
            textAlign: "center",
            color: "#64748b",
            fontStyle: "italic"
          }}>
            لم يتم إرفاق أي مستندات لهذه القضية بعد
          </p>
        </div>
      )}

      {/* التوقيعات */}
      <div style={{ 
        marginTop: "60px", 
        marginBottom: "40px",
        display: "flex",
        justifyContent: "space-between",
        pageBreakInside: "avoid"
      }}>
        <div style={{ textAlign: "center", width: "45%" }}>
          <p style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "60px", color: "#1e293b" }}>
            المحامي المسؤول
          </p>
          <div style={{ 
            borderTop: "2px solid #475569", 
            paddingTop: "10px",
            marginTop: "10px"
          }}>
            <p style={{ fontSize: "14px", color: "#334155" }}>
              {caseData.lawyer || "_________________"}
            </p>
          </div>
        </div>

        <div style={{ textAlign: "center", width: "45%" }}>
          <p style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "60px", color: "#1e293b" }}>
            مدير المكتب
          </p>
          <div style={{ 
            borderTop: "2px solid #475569", 
            paddingTop: "10px",
            marginTop: "10px"
          }}>
            <p style={{ fontSize: "14px", color: "#334155" }}>
              _________________
            </p>
          </div>
        </div>
      </div>

      {/* تذييل التقرير */}
      <div style={{ 
        marginTop: "40px", 
        paddingTop: "20px", 
        borderTop: "2px solid #cbd5e1",
        textAlign: "center",
        color: "#64748b",
        fontSize: "12px"
      }}>
       
        <p style={{ margin: "5px 0" }}>
          هذا التقرير مستخرج من <strong>نظام المرجع برو لإدارة مكاتب المحاماة</strong>
        </p>
        <p style={{ margin: "5px 0" }}>
          www.AlMarjeaPro.com
        </p>
        <p style={{ margin: "5px 0" }}>
          جميع الحقوق محفوظة © {new Date().getFullYear()}
        </p>
      </div>

      {/* أنماط الطباعة */}
      <style>
        {`
          @media print {
            body {
              print-color-adjust: exact;
              -webkit-print-color-adjust: exact;
            }
            @page {
              size: A4;
              margin: 1.5cm;
            }
            .print-only {
              width: 100%;
              max-width: none;
            }
            table {
              page-break-inside: auto;
            }
            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }
            thead {
              display: table-header-group;
            }
            h2 {
              page-break-after: avoid;
            }
          }
        `}
      </style>
    </div>
  );
}
